import _ from 'lodash'
import React from 'react'
import moment from 'moment'
import Store, { defaultAppConfig } from '../store'
import ConfigLoadingModal from 'GeneralUI/ConfigLoadingModal/ConfigLoadingModal.jsx'
import StandardModalContent from 'GeneralUI/StandardModalContent/StandardModalContent.jsx'
import { put, select } from 'redux-saga/effects'

export function * loadLobbyLoginConfig(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'config',
    method: 'search',
    obj: { equal: { app: 'login' } },
    id: null
  })
}

export function * loadLobbyDashboardConfig(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'config',
    method: 'search',
    obj: { equal: { app: 'lobbyDashboard' } },
    id: null
  })
}

export function * loadTreatmentAppConfig(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'xtract/treatmentPlanAppConfig',
    method: 'read',
    obj: null,
    id: null
  })
}

export function * loadGlobalAppConfigAuth() {
  const appConfig = yield select(state => state.appConfig)
  const minModalShowTimeMs = 3000
  const modalCloser = { type: 'close_modal', address: 'appConfig' }
  let showTime = null

  if (
    Object.keys(appConfig).length === 0 ||
    _.isEqual(appConfig, defaultAppConfig)
  ) {
    showTime = new moment()
    // app config has never been loaded and there is no existing data for the app to run
    // from so show the user a modal to explain the slight delay.
    yield put({
      type: 'open_modal',
      address: 'appConfig',
      modalConfig: {
        title: 'Loading Summit...',
        closeable: true,
        content: <ConfigLoadingModal />
      }
    })
  }
  // load globally useful stuff that requires the user to be authenticated
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'xtract/globalAppConfigAuth',
    method: 'read',
    obj: null,
    id: null,
    callbacks: {
      200: response => {
        const completeTime = moment()
        const callDuration = moment.duration(completeTime.diff(showTime))
        const callDurationMs = callDuration.as('milliseconds')
        // ensure the modal stays open at least 3 seconds so its not just a weird
        // flash.
        if (showTime != null && callDurationMs >= minModalShowTimeMs) {
          Store.dispatch(modalCloser)
        } else if (showTime != null) {
          // the 3 seconds isn't up yet so start a time for the rest.
          const remainingTime = minModalShowTimeMs - callDurationMs
          setTimeout(() => Store.dispatch(modalCloser), remainingTime)
        }
      },
      500: () => {
        // update the modal to an error message.
        Store.dispatch({
          type: 'open_modal',
          address: 'appConfig',
          modalConfig: {
            title: 'Loading Summit...',
            closeable: true,
            content: (
              <StandardModalContent
                messageContent={
                  'An error occurred when downloading the summit configuration. Please reload the app to try again and contact Xtract Support if this problem persists.'
                }
                okText={'OK'}
              />
            )
          }
        })
      }
    }
  })
}
